import { CommentCreatedEvent, CommentUpdatedEvent, CommentDeletedEvent } from './commentEvents';

export type CommentBusEvent =
  | { type: 'created'; event: CommentCreatedEvent }
  | { type: 'updated'; event: CommentUpdatedEvent }
  | { type: 'deleted'; event: CommentDeletedEvent };

type Listener = (event: CommentBusEvent) => void;

// Relais entre useBoardChannel (BoardPage) et le CardModal ouvert, sans abonnement Reverb par carte.
const listeners = new Set<Listener>();

export const publishCommentEvent = (event: CommentBusEvent): void => {
  listeners.forEach((listener) => listener(event));
};

export const subscribeToCommentEvents = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
